import styled from "styled-components";
import { ArrowScroll } from "../../../services/visualLibraryService";
import { detailBackgroundStyled } from "../../../styles/shared-styles";
import { directions } from "../../../services/i18nService";

export const DetailPageStyled = styled.section`
  padding: ${props => props.isSeries ? '3.5' : '6'}% ${props => props.theme.baseLayoutPaddingBs}%;
  padding-${props => (props.theme.locale.dir === directions.RIGHT_TO_LEFT ? "left" : "right")}: 0; 
  padding-bottom: 0;
`;

export const DetailContainerStyled = styled.div`
  width: 100%;
  height: 100%;
  ${detailBackgroundStyled.styles};
  will-change: transform;
  transform: ${props => `translateY(${props.position}px)`};
  transition: transform 0.2s linear;
`;

export const DetailWrapperStyled = styled.div`
  width: 100%;
  height: 100%;
  ${detailBackgroundStyled.styles};
`;


export const ArrowScrollStyled = styled(ArrowScroll)`
  position: absolute;
  left: 50%;
  bottom: 5%;
  transform: translateX(-50%);
`;
